import React, { useState } from 'react';
import { useSurvey } from './Context';

const SearchFilter = () => {
    const { searchQuery, setSearchQuery } = useSurvey();
    const [inputValue, setInputValue] = useState(searchQuery);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleSearch = () => {
        window.dataLayer.push({
            event: 'survey_search_submit',
            value: inputValue,
            page: window.location.pathname,
        });

        setSearchQuery(inputValue);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
        }
    };

    return (
        <div className="filter-item search-filter">
            <label className="sr-only" htmlFor="search_input">Search a Question</label>
            <input
                type="text"
                id="search_input"
                name="search_input"
                placeholder="Search a Question"
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
            />
            <button className="search-btn" type="button" onClick={handleSearch}>
                <span className="sr-only">Search</span>
                <svg className="btn-icon" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M9.96544 11.5261C9.13578 12.1382 8.11014 12.5 7 12.5C4.23858 12.5 2 10.2614 2 7.5C2 4.73858 4.23858 2.5 7 2.5C9.76142 2.5 12 4.73858 12 7.5C12 8.61014 11.6382 9.63578 11.0261 10.4654L13.7803 13.2197C14.0732 13.5126 14.0732 13.9874 13.7803 14.2803C13.4874 14.5732 13.0126 14.5732 12.7197 14.2803L9.96544 11.5261ZM10.5 7.5C10.5 9.433 8.933 11 7 11C5.067 11 3.5 9.433 3.5 7.5C3.5 5.567 5.067 4 7 4C8.933 4 10.5 5.567 10.5 7.5Z" /></svg>
            </button>
        </div>
    );
};

export default SearchFilter;
